export default class Gate{

    constructor(user){
        this.user = user;
    }

    isType(type){
        return Array.isArray(type) ? type.includes(this.user.type) : type == this.user.type;
    }

    hasFeaturePermission(feature, user = null){
        let user_can = false;
        let features = user ? user.features : this.user.features;
        $.each(features, function(index, user_feature){
            if(user_feature.tag == feature){
                user_can = user_feature.value > 0;
                return;
            }
        });
        return user_can;
    }

    hasActiveSubscription(){
        return this.user.main_subscription ? this.user.main_subscription.is_active : false;
    }

    upgradeSubscription(){
        return this.user.main_subscription && this.user.main_subscription.plan_id < 3;
    }

    language(){
        return this.user.language;
    }

    name(){
        return this.user.name;
    }
}

